import { initSplitApi } from './init'
import * as q from './elastic-query'

export const userAPI = initSplitApi.injectEndpoints({
    reducerPath: 'user',
    endpoints: (builder) => ({
        userAuth: builder.mutation({
            query: (params) => {
                return {
                    url: `users/authenticate`,
                    method: 'POST',
                    service: 'mongoDBAuth',
                    config: {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        withCredentials: true,
                    },
                    body: {
                        email: params.username,
                        password: params.password
                    }
                };
            }
        }),
        userCognito: builder.mutation({
            query: (params) => ({
                url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/user/create`,
                method: 'POST',
                body: params,
                service: 'amplify'
            }),
            providesTags: ['userList']
        }),
        disableUser: builder.mutation({
            query: (params) => ({
                url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/user/disable`,
                method: 'POST',
                body: params,
                service: 'amplify'
            }),
            providesTags: ['userList']
        }),
        changePassword: builder.mutation({
            query: (params) => ({
                url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/user/reset/password`,
                method: 'POST',
                body: params,
                service: 'amplify'
            }),
            providesTags: ['userList']
        }),
        userCreate: builder.mutation({
            query: (body) => {
                console.log('body', body);
                return {
                    url: `users/_doc/${body.id}`,
                    method: 'PUT',
                    service: 'elastic',
                    body
                };
            },
            providesTags: ['usersList']
        }),
        stripeUserCreate: builder.mutation({
            query: (body) => {
                return {
                    url: `/payment/customer/create`,
                    method: 'POST',
                    service: 'stripe',
                    body
                };
            },
            providesTags: ['usersList']
        }),
        userEdit: builder.mutation({
            query: (body) => {
                return {
                    url: `users/_update/${body.doc.id}`,
                    method: 'POST',
                    service: 'elastic',
                    body
                };
            },
            invalidatesTags: ['userList', 'userDetails']
        }),
        userDelete: builder.mutation({
            query: (params) => {
                return {
                    url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/user/delete`,
                    method: 'POST',
                    body: params,
                    service: 'amplify'
                };
            },
            providesTags: ['userList']
        }),
        userQList: builder.query({
            query: (params) => ({
                url: `stage-users/_search`,
                method: 'POST',
                body: params.q,
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['userList']
        }),
        userList: builder.query({
            query: (criteria) => ({
                url: `users/_search`,
                method: 'POST',
                body: {
                    "query": { "match_all": {} },
                    "size": criteria.limit,
                    "from": criteria.page * criteria.limit
                },
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response.hits.hits.map(h => h._source);
                    var c = response.hits.total.value;
                    return { rows: r, count: c }
                }
            },
            providesTags: ['userList']
        }),
        userCognitoList: builder.query({
            query: (criteria) => ({
                url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/user/list`,
                method: 'POST',
                body: {
                    "query": { "match_all": {} },
                    "size": criteria.limit,
                    "from": criteria.page * criteria.limit
                },
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response.hits.hits.map(h => h._source);
                    var c = response.hits.total.value;
                    return { rows: r, count: c }
                }
            },
            providesTags: ['userList']
        }),
        userCognitoDetails: builder.query({
            query: (params) => ({
                url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/user/get`,
                method: 'POST',
                body: params,
                service: 'amplify'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.Username?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['userDetails']
        }),
        userStripeDetails: builder.query({
            query: (params) => ({
                url: `https://dy7oauhne7.execute-api.us-west-2.amazonaws.com/prod/payment/customer/retrieve`,
                method: 'POST',
                body: params,
                service: 'stripe'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.Username?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['userDetails']
        }),
        userDetails: builder.query({
            query: (params) => ({
                url: `users/_search`,
                method: 'POST',
                body: {
                    "query": {
                        "bool": {
                            "must": [
                                {
                                    "match": { "id.keyword": params.id }
                                }
                            ]
                        }
                    }
                },
                service: 'elastic'
            }),

            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response.hits.hits[0]._source;
                    return r
                }
            },
            providesTags: ['userDetails']
        }),
        smList: builder.query({
            query: (params) => ({
                url: `users/_search`,
                method: 'POST',
                body: {
                    "query": {
                        "bool": {
                            "must": [
                                { "match": { "role": "sm" } },
                                { "match": { "orgId": params.orgId } }
                            ]
                        }
                    }
                },
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response.hits.hits;
                    return r
                }
            },
            providesTags: ['userDetails']
        }),
    }),

    overrideExisting: false
})

export const {
    useUserCognitoMutation,
    useUserCognitoDetailsQuery,
    useUserStripeDetailsQuery,
    useDisableUserMutation,
    useChangePasswordMutation,
    useUserCreateMutation,
    useStripeUserCreateMutation,
    useUserDeleteMutation,
    useUserEditMutation,
    useUserDetailsQuery,
    useUserQListQuery,
    useUserListQuery,
    useUserAuthMutation,
    useSmListQuery
} = userAPI